import { gql } from '@apollo/client';

export const MAP_RESULT_CREATE = gql`
  mutation MapResults($snapshot: String!, $user: JSON, $plan: JSON, $map: JSON) {
    mapResultCreate(snapshot: $snapshot, user: $user, map: $map, plan: $plan) {
      id
    }
  }
`;

export const MAP_RESULT_DELETE = gql`
  mutation MapResults($id: ID!) {
    mapResultDelete(id: $id)
  }
`;
